import { render, staticRenderFns } from "./DataTableItemFlowType.vue?vue&type=template&id=0c15b531&"
import script from "./DataTableItemFlowType.vue?vue&type=script&lang=ts&"
export * from "./DataTableItemFlowType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports